exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3gpf2iT9{height:3px;margin-top:-3px;background-color:#26c6da}", ""]);

// exports
exports.locals = {
	"marker": "_3gpf2iT9"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[hash:base64:8]"}!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist!./src/shared/elementMarker/style.less
// module id = 1233
// module chunks = 1